module.exports = __webpack_public_path__ + "media/images/num3_ic-off-201388c76192fb03460cff46e13ef9be.svg";